const getImageIds = mapShapes => {
  const ids = [];
  mapShapes.forEach(({
    shapeData,
    imageId
  }) => {
    if (imageId) ids.push(imageId);
    if (shapeData.imageId) ids.push(shapeData.imageId);
  });
  return [...new Set(ids)];
};
export default getImageIds;
//# sourceMappingURL=get-image-ids.js.map